"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var LinkPreviewFull_1 = require("./components/LinkPreviewFull");
var isLinkPreviewOptionDirty_1 = require("./utils/isLinkPreviewOptionDirty");
var discardLinkPreviewOption_1 = require("./actions/discardLinkPreviewOption");
var saveLinkPreviewOption_1 = require("./actions/saveLinkPreviewOption");
var LinkPreviewOption = {
    key: 'linkPreview',
    titleStringKey: 'optionTitle_linkPreview',
    searchTermsStringKey: 'optionTitle_linkPreview',
    fullOptionFormSettings: {
        render: function () { return React.createElement(LinkPreviewFull_1.default, null); },
        isDirty: isLinkPreviewOptionDirty_1.default,
        onSave: saveLinkPreviewOption_1.default,
        onDiscard: discardLinkPreviewOption_1.default,
    },
};
exports.default = LinkPreviewOption;
//# sourceMappingURL=LinkPreviewOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-link-preview-option/lib/LinkPreviewOption.js
// module id = 5137
// module chunks = 2